export class SoundcloudChannel {
  playback_count: string;
  uri: string;
  id: string;
  avatar_url:string;
  username:string;
  favoritings_count:string;
  artwork_url:string;
  title: string;
  duration: number;
  created_at : Date;
  waveform_url: string;
  permalink: string

  constructor(obj?: any) {
    this.uri = obj && obj.uri || null;
    this.id = obj && obj.id || null;
    this.avatar_url = obj && obj.avatar_url || null;
    this.permalink = obj && obj.permalink || null;
    this.username = obj && obj.username || null;
    this.playback_count = obj && obj.playback_count || null;
    this.favoritings_count = obj && obj.favoritings_count || null;
    this.artwork_url = obj && obj.artwork_url || null;
    this.title = obj && obj.title || null;
    this.duration = obj && obj.duration || null;
    this.created_at = obj && obj.created_at || null;
    this.waveform_url = obj && obj.waveform_url || null;

  }
}

export class SoundCloudApiSearchResult{
  avatar_url: string;
  comments_count: number;
  first_name: string;
  followers_count: number;
  followings_count: number;
  full_name: string;
  id: number;
  kind: string;
  last_modified: string;
  last_name: string;
  likes_count: number;
  online: boolean;
  permalink: string;
  permalink_url: string;
  plan: string;
  playlist_count: number;
  public_favorites_count: number;
  reposts_count: number;
  track_count: number;
  uri: string;
  username: string;
  website: string;
  website_title: string;
}
